import { Rate } from "antd";
import styled from "styled-components";
import { theme } from "../../../theme";

const RateStar = styled(Rate)`
  & .ant-rate-star {
    margin: 0;
    &.ant-rate-star-full {
      color: ${theme.colors.orange1};
    }
    &.ant-rate-star-zero {
      color: ${theme.colors.gray7};
    }
  }
`;

export { RateStar };
